export default __webpack_public_path__ + "static/media/Royal Dragon Elite Cloak.5343dd27.jpg";